import { Grid, minmax, repeat } from '@adobe/react-spectrum';
import React from 'react';

import { useMediaQuery } from '@exchange-frontends/custom-hooks';

/** @param {React.PropsWithChildren} */
const PublisherAppsGrid = ({ children }) => {
  const twoColumns = useMediaQuery('(min-width: 900px) and (max-width:1265px)');

  return (
    <Grid
      gap="size-200"
      columns={repeat('auto-fill', minmax('min(100%, max(270px, 100%/3.5))', '1fr'))}
      justifyContent={twoColumns ? 'space-between' : null}
    >
      {children}
    </Grid>
  );
};

export default PublisherAppsGrid;
